<template>
    <div class="popup-container">
        <div class="popup">
            <div class="popup__title">Confirmation</div>
            <p>You are about to cancel your itinerary creation. This means that all information in this itinerary will be lost. <br /> Do you wish to continue?</p>

            <div class="popup__buttons">
                <button class="white-btn"
                    v-on:click="closePopup">Save as Draft</button>
                <button class="sub-btn confirm-btn"
                    v-on:click="closePopup">Delete Itinerary</button>
            </div>
        </div>
    </div>
</template>

<script>
    import Eventbus from '../modules/eventbus'

    export default {
        name: 'CancelPopup',
        methods: {
            closePopup: function() {
                Eventbus.$emit('closeCancelPopup')
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../styles/confirmationPopup";

    .popup__title + p {
        max-width: 421px;
    }

    .white-btn,
    .confirm-btn {
        padding: 0 27px;

        @media all and (min-width: $breakpoint + 1) {
            width: auto;
            max-width: none;
        }

        @media all and (max-width: $breakpoint) {
            padding: 0;
        }
    }
</style>
